import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IHighlightItem } from '../_shared/models/highlight-item.model';
import { ITextHighLight } from '../_shared/models/text-highlight.model';
import { GridComponent } from '../grid/grid.component';
import { HeadingComponent } from '../heading/heading.component';
import { HighlightedItemComponent } from '../highlighted-item/highlighted-item.component';
import { TextHtmlComponent } from '../text-html/text-html.component';


@Component({
    selector: 'sirius-text-highlight',
    templateUrl: './text-highlight.component.html',
    styleUrls: ['./text-highlight.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, HeadingComponent, HighlightedItemComponent, TextHtmlComponent]
})
export class TextHighlightComponent implements OnInit, IDynamicElement {
    @Input() config?: ITextHighLight;
    @Input() title = '';
    @Input() textHtml = '';
    @Input() highlightTitle = '';
    @Input() highlightText = '';
    @Input() highlightedItems: IHighlightItem[] = [];

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.textHtml = this.config.textHtml;
            this.highlightTitle = this.config.highlightTitle;
            this.highlightText = this.config.highlightText;
            this.highlightedItems = this.config.highlightedItems;
        }
    }
}
